import { Injectable } from '@angular/core';
import { MeasureContext } from '../../models/models';

@Injectable()
export class MeasureContextLocalService {

  constructor() {
  }

  public static deleteCurrentMeasureContext(): void {
    localStorage.removeItem('measureContext');
  }

  public static getCurrentMeasureContext(): MeasureContext {
    return JSON.parse(localStorage.getItem('measureContext'));
  }

  public static setCurrentMeasureContext(measureContext: MeasureContext) {
    localStorage.setItem('measureContext', JSON.stringify(measureContext));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-data-services/measure-context-local.service.ts